import { z } from 'zod';
import { TableSchema } from '../table';

export const EnvironmentSchema = z.object({
    declarations: z.array(TableSchema),
});
